export default __webpack_public_path__ + "cardModelNlp-sill49ba08.png";